import { render, staticRenderFns } from "./file_browser_toggle.vue?vue&type=template&id=517c10e4"
import script from "./file_browser_toggle.vue?vue&type=script&lang=js"
export * from "./file_browser_toggle.vue?vue&type=script&lang=js"
import style0 from "./file_browser_toggle.vue?vue&type=style&index=0&id=517c10e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports